var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2916 9.80704C15.7125 5.22789 8.2882 5.22789 3.70906 9.80704C3.31854 10.1976 2.68537 10.1976 2.29485 9.80704C1.90432 9.41651 1.90432 8.78335 2.29485 8.39283C7.65504 3.03263 16.3456 3.03263 21.7058 8.39283C22.0963 8.78335 22.0963 9.41651 21.7058 9.80704C21.3153 10.1976 20.6821 10.1976 20.2916 9.80704Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60112 12.6103C9.58302 9.62839 14.4176 9.62839 17.3995 12.6103C17.7901 13.0008 18.4232 13.0008 18.8138 12.6103C19.2043 12.2198 19.2043 11.5866 18.8138 11.1961C15.0508 7.43312 8.94986 7.43312 5.18691 11.1961C4.79638 11.5866 4.79638 12.2198 5.18691 12.6103C5.57743 13.0008 6.2106 13.0008 6.60112 12.6103Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54006 15.4057C10.9247 14.0211 13.1697 14.0211 14.5544 15.4057C14.9449 15.7963 15.578 15.7963 15.9686 15.4057C16.3591 15.0152 16.3591 14.382 15.9686 13.9915C13.8029 11.8258 10.2916 11.8258 8.12585 13.9915C7.73532 14.382 7.73532 15.0152 8.12585 15.4057C8.51637 15.7963 9.14954 15.7963 9.54006 15.4057Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0944 19.6218C12.9932 19.6218 13.7218 18.8932 13.7218 17.9945C13.7218 17.0958 12.9932 16.3672 12.0944 16.3672C11.1957 16.3672 10.4671 17.0958 10.4671 17.9945C10.4671 18.8932 11.1957 19.6218 12.0944 19.6218Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataOutline);
export default __webpack_public_path__ + "static/media/data_outline.78f8bd8634585828e543a467dfb4b11e.svg";
export { ForwardRef as ReactComponent };